import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/api/baseQuery';

export const TOGGLE_ALERT = 'toggleAlert';
export const SAVE_ALERT = 'saveAlert';
export const DELETE_ALERT = 'deleteAlert';

export const alertApi = createApi({
  reducerPath: 'alertApi',
  baseQuery,
  endpoints: (builder) => ({
    [SAVE_ALERT]: builder.mutation<any, any>({
      query: ({ datasourceId, payload }) => ({
        url: `datasources/${datasourceId}/alerts`,
        method: 'POST',
        body: payload,
      }),
    }),
    [TOGGLE_ALERT]: builder.mutation<any, any>({
      query: ({ datasourceId, alertId, disabled }) => ({
        url: `datasources/${datasourceId}/alerts/${alertId}/disable/${disabled}`,
        method: 'POST',
      }),
    }),
    [DELETE_ALERT]: builder.mutation<any, any>({
      query: ({ datasourceId, alertId }) => ({
        url: `datasources/${datasourceId}/alerts/${alertId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useToggleAlertMutation,
  useDeleteAlertMutation,
  useSaveAlertMutation,
} = alertApi;
